exports.default = {
  locale: {
    'zh-cn': '简体',
    'zh-tw': '繁体',
    'en-us': 'English'
  },
  router: {
    'home': '首页',
    'image-generation': 'AI 图片',
    'video-generation': 'AI 视频',
    'web-generation': 'AI 网页',
    'user-center': '用户中心',
    'user-set': '用户设置',
    'team-invitation': '成员邀请',
    'team-manage': '团队管理',
    'team-set': '团队设置',
    'team-member-department': '成员部门',
    'team-member-approve': '成员审批',
    'team-role-management': '角色管理',
    'team-limit-management': '限额管理',
    'team-consumption-records': '消费记录',
    'chat-creation': '对话',
    'agent-creation': '智能体管理',
    'agent-setting': '智能体设置',
    'agent-link': '连接集成',
    'agent-data-analysis': '数据分析',
    'agent-user-feedback': '用户反馈',
    'agent-member-setting': '成员设置',
    'chat-apps': '智能体中心',
    'chat-export': '导出会话记录',
    'chat-img-mj': 'MidJourney 绘画中心',
    'chat-img-sd': 'Stable Diffusion 绘画中心',
    'chat-images-wall': '作品展示',
    'dashboard': '发现',
    'invitation': '推广计划',
    'knowledge': '项目',
    'knowledge-manage': '项目管理',
    'asset': '资产'
  }
}
